'use strict';

Odigeo.defineWidget('usersmanager', Odigeo.Widget.extend({
    modelClass: require('./model'),

    getUserDTO: function() {
        return this.model.get('userDTO');
    },

    exposedMethods: {
        'submitUserRequest': 'addUserRequest',
        'clearUser': 'clearUser',
        'savePassenger': 'savePassenger',
        'saveAllPassenger': 'saveAllPassenger',
        'saveUserProfile': 'saveUserProfile',
        'saveAllPassengersData': 'saveAllPassengersData',
        'updateUserData': 'updateUserData',
        'deletePassenger': 'deletePassenger',
        'saveAllPassengersDataWithoutOverwrite': 'saveAllPassengersDataWithoutOverwrite',
        'mixUserAndMember': 'mixUserAndMember',
    },

    // Exposes a interface to access the widget public methods
    execute: function(func, params) {
        if (this.exposedMethods[func]) {
            this.model[this.exposedMethods[func]](params);
        }
        return this;
    },
}));
